export default __webpack_public_path__ + "static/media/solidworks.66d40f37.jpg";